// Plant.js  — AddPlant
import React, { useState } from 'react';
import "../../Assets/Styles/Form.css";
import AxiosInstance from '../Axios/AxiosInstance';
import * as FaIcons from "react-icons/fa";

// FIX: moved to shared utility — no longer defined or exported from here
import { convertBoundaryToJson } from './BoundaryUtils';

const initialFormState = {
    company_id: '',
    plant_name: '',
    contact_person_name: '',
    contact_number: '',
    contact_email_id: '',
    plant_address: '',
    plant_lat: '',
    plant_lon: '',
    plant_area: '',
    plant_boundry: '',          // raw CSV entered by the user
    plant_boundry_raw: '',      // kept in sync with the textarea for display
    plant_time_zone_diff: '',
    critical_battery_level: '',
    plant_added_date: '',
    company_name: '',
    plant_id: '0',
    plant_mode: 'Insert',
    message: '',
};

export const AddPlant = () => {
    const _userID = sessionStorage.getItem("user_id");

    const [formData, setFormData] = useState(initialFormState);
    const [errors, setErrors] = useState({});
    const [boundaryPreview, setBoundaryPreview] = useState(""); // shows converted JSON to user

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Live-preview the JSON conversion as the user types in the boundary field
        if (name === "plant_boundry") {
            const { json, error } = convertBoundaryToJson(value);
            setBoundaryPreview(error ? `⚠ ${error}` : json);
        }
    };

    const validateForm = (data) => {
        const errs = {};

        if (!data.company_id.toString().trim())
            errs.company_id = 'Company ID is required';
        else if (data.company_id.toString().length > 10)
            errs.company_id = 'Company ID must not exceed 10 digits';

        if (!data.plant_name.trim())
            errs.plant_name = 'Farm name is required';
        else if (data.plant_name.length > 50)
            errs.plant_name = 'Farm name must not exceed 50 characters';

        if (!data.contact_person_name.trim())
            errs.contact_person_name = 'Contact person is required';
        else if (data.contact_person_name.length > 50)
            errs.contact_person_name = 'Contact person name must not exceed 50 characters';

        if (!data.contact_number.trim())
            errs.contact_number = 'Contact number is required';
        else if (data.contact_number.length > 35)
            errs.contact_number = 'Contact number must not exceed 35 characters';

        if (!data.contact_email_id.trim())
            errs.contact_email_id = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(data.contact_email_id))
            errs.contact_email_id = 'Email is invalid';

        if (!data.plant_address.trim())
            errs.plant_address = 'Farm address is required';
        else if (data.plant_address.length > 100)
            errs.plant_address = 'Farm address must not exceed 100 characters';

        if (!data.plant_lat.trim())
            errs.plant_lat = 'Farm latitude is required';
        else if (isNaN(parseFloat(data.plant_lat)))
            errs.plant_lat = 'Farm latitude must be a valid number';

        if (!data.plant_lon.trim())
            errs.plant_lon = 'Farm longitude is required';
        else if (isNaN(parseFloat(data.plant_lon)))
            errs.plant_lon = 'Farm longitude must be a valid number';

        if (!String(data.plant_time_zone_diff).trim())
            errs.plant_time_zone_diff = 'Time zone difference is required';
        else if (String(data.plant_time_zone_diff).length > 5)
            errs.plant_time_zone_diff = 'Time zone difference must not exceed 5 digits';

        if (!String(data.critical_battery_level).trim())
            errs.critical_battery_level = 'Battery level is required';
        else if (String(data.critical_battery_level).length > 3)
            errs.critical_battery_level = 'Battery level must not exceed 3 digits';

        // Boundary: convert CSV → JSON and validate
        if (!data.plant_boundry.trim()) {
            errs.plant_boundry = 'Farm boundary is required';
        } else {
            const { error } = convertBoundaryToJson(data.plant_boundry);
            if (error) errs.plant_boundry = error;
        }

        return errs;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validateForm(formData);
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            setFormData((prev) => ({ ...prev, message: 'Please fix the errors below.' }));
            return;
        }

        try {
            // Convert boundary CSV → JSON string before sending to API
            const { json: boundaryJson } = convertBoundaryToJson(formData.plant_boundry);

            const payload = {
                ...formData,
                plant_boundry: boundaryJson,   // stored as JSON in DB
                user_id: _userID,
            };

            await AxiosInstance.post("/Plant", payload);

            setFormData({ ...initialFormState, message: 'Farm added successfully!' });
            setBoundaryPreview("");
        } catch (error) {
            console.error('Submission error:', error);
            setFormData((prev) => ({ ...prev, message: 'Submission failed. Please try again.' }));
        }
    };

    return (
        <div className="container-ul" style={{ marginTop: '11%' }}>
            <div className="form-container">
                <h2 className="form-title"><FaIcons.FaRegEdit /> Add New Farm</h2>

                {formData.message && (
                    <div className={`alert ${formData.message.includes('successfully') ? 'alert-success' : 'alert-danger'}`}>
                        {formData.message}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div>
                        <input className="form-input" type="number" name="company_id"
                            value={formData.company_id} onChange={handleChange}
                            placeholder="Company ID (max 10 digits)" max="9999999999" />
                        {errors.company_id && <span className="error-message">{errors.company_id}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="plant_name"
                            maxLength="50" value={formData.plant_name} onChange={handleChange}
                            placeholder="Farm name (max 50 chars)" />
                        {errors.plant_name && <span className="error-message">{errors.plant_name}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="contact_person_name"
                            maxLength="50" value={formData.contact_person_name} onChange={handleChange}
                            placeholder="Contact person (max 50 chars)" />
                        {errors.contact_person_name && <span className="error-message">{errors.contact_person_name}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="contact_number"
                            maxLength="35" value={formData.contact_number} onChange={handleChange}
                            placeholder="Contact number (max 35 chars)" />
                        {errors.contact_number && <span className="error-message">{errors.contact_number}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="contact_email_id"
                            maxLength="30" value={formData.contact_email_id} onChange={handleChange}
                            placeholder="Contact email (max 30 chars)" />
                        {errors.contact_email_id && <span className="error-message">{errors.contact_email_id}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="plant_address"
                            maxLength="100" value={formData.plant_address} onChange={handleChange}
                            placeholder="Farm address (max 100 chars)" />
                        {errors.plant_address && <span className="error-message">{errors.plant_address}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="plant_lat"
                            maxLength="15" value={formData.plant_lat} onChange={handleChange}
                            placeholder="Farm latitude  e.g. 11.234567" />
                        {errors.plant_lat && <span className="error-message">{errors.plant_lat}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="plant_lon"
                            maxLength="15" value={formData.plant_lon} onChange={handleChange}
                            placeholder="Farm longitude  e.g. 73.345678" />
                        {errors.plant_lon && <span className="error-message">{errors.plant_lon}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="plant_area"
                            maxLength="5" value={formData.plant_area} onChange={handleChange}
                            placeholder="Farm area (max 5 chars)" />
                        {errors.plant_area && <span className="error-message">{errors.plant_area}</span>}
                    </div>

                    {/* ---- Boundary input with live JSON preview ---- */}
                    <div>
                        <textarea
                            className="form-input"
                            name="plant_boundry"
                            value={formData.plant_boundry}
                            onChange={handleChange}
                            rows={3}
                            placeholder="Enter boundary as comma-separated lat/lon pairs (min 3, max 15 pairs)&#10;e.g. 11.234567, 73.345678, 10.234577, 73.345678, 11.45689, 73.23567999"
                            style={{ resize: 'vertical', fontFamily: 'monospace' }}
                        />
                        {errors.plant_boundry && <span className="error-message">{errors.plant_boundry}</span>}

                        {/* Preview panel */}
                        {formData.plant_boundry.trim() && (
                            <div style={{
                                marginTop: '4px',
                                padding: '8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                fontFamily: 'monospace',
                                background: boundaryPreview.startsWith('⚠') ? '#fff3cd' : '#d4edda',
                                color: boundaryPreview.startsWith('⚠') ? '#856404' : '#155724',
                                wordBreak: 'break-all',
                            }}>
                                <strong>JSON preview: </strong>{boundaryPreview}
                            </div>
                        )}
                    </div>

                    <div>
                        <input className="form-input" type="text" name="plant_time_zone_diff"
                            maxLength="5" value={formData.plant_time_zone_diff} onChange={handleChange}
                            placeholder="Time zone difference (max 5 digits)" />
                        {errors.plant_time_zone_diff && <span className="error-message">{errors.plant_time_zone_diff}</span>}
                    </div>
                    <div>
                        <input className="form-input" type="text" name="critical_battery_level"
                            maxLength="3" value={formData.critical_battery_level} onChange={handleChange}
                            placeholder="Critical battery level (max 3 digits)" />
                        {errors.critical_battery_level && <span className="error-message">{errors.critical_battery_level}</span>}
                    </div>

                    <div className="row" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <div className="col-5">
                            <button className="submit-button" type="submit">
                                <FaIcons.FaSave /> Submit
                            </button>
                        </div>
                        <div className="col-5">
                            <a style={{ textDecoration: 'none' }}
                                className="submit-button"
                                href="#/search-plant">
                                <FaIcons.FaSearch />&nbsp;Search Farm
                            </a>
                        </div>
                    </div>
                </form>
                <p></p>
                <p></p>
            </div>
        </div>
    );
};

export default AddPlant;